export const FETCH_PRODUCT_CONFIG = "FETCH_PRODUCT_CONFIG";
export const UPDATE_PRODUCT_CONFIG = "UPDATE_PRODUCT_CONFIG";
